import * as yup from "yup";

export const validateMandatorySchema = async (formData, currentStepIndex) => {
  switch (currentStepIndex) {
    case 1:
      return await validateQuestionOne(formData);
    case 2:
      return await validateQuestionTwo(formData);
    case 6:
      return await validateQuestionSix(formData);
    case 8:
      return await validateQuestionEight(formData);
    case 10:
      return await validateQuestionTen(formData);
    default:
      return;
  }
};

export const questionOneSchema = yup.object().shape({
  coachingMethodologyRating: yup
    .string()
    .min(1, "Please select a rating for Coaching Methodology"),
});

export const validateQuestionOne = async value => {
  try {
    await questionOneSchema.validate(value);
  } catch (error) {
    return { error: error.message };
  }
};

export const questionTwoSchema = yup.object().shape({
  coachingMethodologyRatingFactors: yup
    .array()
    .of(
      yup.object({
        id: yup.string(),
        description: yup.string(),
        checked: yup.boolean(),
      })
    )
    .test("is any fields selected?", "You must select an option", factors => {
      return factors.some(item => item.checked);
    }),
  coachingMethodologyFeedback: yup
    .string()
    .min(1, "Please fill in your feedback on coaching methodology")
    .max(65535, textInput => {
      const length = textInput.value.length;
      return `Must be less than 65535 characters (${length} / 65535)`;
    }),
});

export const validateQuestionTwo = async value => {
  try {
    await questionTwoSchema.validate(value);
  } catch (error) {
    return { error: error.message };
  }
};
export const questionSixSchema = yup.object().shape({
  flashCoachTrainingRating: yup
    .array()
    .of(
      yup.object({
        rating: yup.number(),
        name: yup.string(),
        description: yup.string(),
        isSelected: yup.boolean(),
        imageSrc: yup.string(),
      })
    )
    .test("is any field selected?", "You must select a rating", rating => {
      return rating.find(item => item.isSelected);
    }),
});
export const validateQuestionSix = async value => {
  try {
    await questionSixSchema.validate(value);
  } catch (error) {
    return { error: error.message };
  }
};
export const questionEightSchema = yup.object().shape({
  easeOfNavigationFeedback: yup
    .string()
    .min(1, "Please fill in your feedback for ease of navigation")
    .max(65535, textInput => {
      const length = textInput.value.length;
      return `Must be less than 65,535 characters (${length} / 65,535)`;
    }),
});
export const validateQuestionEight = async value => {
  try {
    await questionEightSchema.validate(value);
  } catch (error) {
    return { error: error.message };
  }
};
export const questionTenSchema = yup.object().shape({
  accessibilityFactors: yup
    .array()
    .of(
      yup.object({
        id: yup.string(),
        description: yup.string(),
        checked: yup.boolean(),
      })
    )
    .test("is any fields selected?", "You must select an option", options => {
      return options.some(item => item.checked);
    }),
});

export const validateQuestionTen = async value => {
  try {
    const othersCheckboxIsFilled = value.accessibilityFactors.filter(
      item => item.id === "5" && item.checked
    );

    if (
      othersCheckboxIsFilled &&
      othersCheckboxIsFilled.length > 0 &&
      !value.accessibilityFactorsOthers
    ) {
      throw new Error("Please fill up the text input");
    }
    await questionTenSchema.validate(value);
  } catch (error) {
    return { error: error.message };
  }
};
